import instance from './DefaultApi';

export default class UploaderFileService {
    ControllerName = 'Upload';

    // create de map data
    UploadMappingExcel(data) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/CSVUpload`, data).then(res => res)
    }   
}